// src/components/sections/EmergencyCTA.js
import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaPhoneAlt, FaCalendarAlt, FaWhatsapp, FaAmbulance, FaClock } from 'react-icons/fa';

const EmergencyCTA = () => {
    return (
        <section className="section-padding" style={{ position: 'relative', overflow: 'hidden' }}>
            {/* Background Pattern */}
            <div className="position-absolute w-100 h-100" style={{ zIndex: 0 }}>
                <div className="position-absolute" style={{ top: '20%', left: '5%' }}>
                    <div className="rounded-circle" style={{ width: '200px', height: '200px', backgroundColor: 'var(--teal-light)', opacity: 0.3 }}></div>
                </div>
                <div className="position-absolute" style={{ bottom: '10%', right: '10%' }}>
                    <div className="rounded-circle" style={{ width: '150px', height: '150px', backgroundColor: 'var(--coral)', opacity: 0.1 }}></div>
                </div>
            </div>

            <Container style={{ position: 'relative', zIndex: 1 }}>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                    className="text-center mb-5"
                >
                    <h2 className="display-5 fw-bold mb-3" style={{ color: 'var(--dark-teal)' }}>
                        Immediate Care When You Need It
                    </h2>
                    <p className="lead" style={{ color: '#666', maxWidth: '700px', margin: '0 auto' }}>
                        Quick access to emergency services and convenient appointment scheduling
                    </p>
                </motion.div>

                <Row className="g-4 mb-5">
                    <Col lg={4} md={6}>
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.1 }}
                            viewport={{ once: true }}
                        >
                            <div
                                className="p-5 rounded text-white text-center h-100 healthcare-card"
                                style={{
                                    background: 'linear-gradient(135deg, var(--coral) 0%, #FF6347 100%)',
                                    border: 'none'
                                }}
                            >
                                <div className="mb-4">
                                    <div className="rounded-circle d-inline-flex align-items-center justify-content-center p-4 mb-3"
                                        style={{
                                            backgroundColor: 'rgba(255,255,255,0.2)',
                                            width: '100px',
                                            height: '100px'
                                        }}
                                    >
                                        <FaAmbulance size={40} />
                                    </div>
                                    <h3 className="fw-bold mb-3">Medical Emergency</h3>
                                    <p className="mb-4 opacity-90">
                                        Immediate medical assistance available 24/7
                                    </p>
                                    <div className="d-flex align-items-center justify-content-center mb-4">
                                        <FaPhoneAlt className="me-3" />
                                        <h2 className="fw-bold mb-0">(212) 555-EMER</h2>
                                    </div>
                                    <Button
                                        variant="light"
                                        className="w-100 py-3 fw-bold"
                                        style={{ borderRadius: '50px' }}
                                    >
                                        <FaPhoneAlt className="me-2" />
                                        Call Emergency Now
                                    </Button>
                                </div>
                            </div>
                        </motion.div>
                    </Col>

                    <Col lg={4} md={6}>
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.2 }}
                            viewport={{ once: true }}
                        >
                            <div
                                className="p-5 rounded text-center h-100 healthcare-card"
                                style={{
                                    backgroundColor: 'white',
                                    border: '2px solid var(--primary-teal)'
                                }}
                            >
                                <div className="mb-4">
                                    <div className="rounded-circle d-inline-flex align-items-center justify-content-center p-4 mb-3"
                                        style={{
                                            backgroundColor: 'var(--teal-light)',
                                            width: '100px',
                                            height: '100px',
                                            color: 'var(--primary-teal)'
                                        }}
                                    >
                                        <FaCalendarAlt size={40} />
                                    </div>
                                    <h3 className="fw-bold mb-3" style={{ color: 'var(--dark-teal)' }}>
                                        Book Appointment
                                    </h3>
                                    <p className="mb-4" style={{ color: '#666' }}>
                                        Schedule consultations with specialists
                                    </p>
                                    <div className="mb-4">
                                        <div className="d-flex align-items-center justify-content-center mb-2">
                                            <FaClock className="me-2" style={{ color: 'var(--primary-teal)' }} />
                                            <span style={{ color: '#666' }}>Next available: Today</span>
                                        </div>
                                    </div>
                                    <Button
                                        className="btn-primary-teal w-100 py-3 fw-bold"
                                    >
                                        <FaCalendarAlt className="me-2" />
                                        Book Online Now
                                    </Button>
                                </div>
                            </div>
                        </motion.div>
                    </Col>

                    <Col lg={4} md={12}>
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.3 }}
                            viewport={{ once: true }}
                        >
                            <div
                                className="p-5 rounded text-center h-100 healthcare-card"
                                style={{
                                    background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
                                    color: 'white',
                                    border: 'none'
                                }}
                            >
                                <div className="mb-4">
                                    <div className="rounded-circle d-inline-flex align-items-center justify-content-center p-4 mb-3"
                                        style={{
                                            backgroundColor: 'rgba(255,255,255,0.2)',
                                            width: '100px',
                                            height: '100px'
                                        }}
                                    >
                                        <FaWhatsapp size={40} />
                                    </div>
                                    <h3 className="fw-bold mb-3">Quick Enquiry</h3>
                                    <p className="mb-4 opacity-90">
                                        Get instant responses via WhatsApp
                                    </p>
                                    <div className="mb-4">
                                        <div className="d-flex align-items-center justify-content-center mb-2">
                                            <FaClock className="me-2" />
                                            <span className="opacity-90">Response time: 5 mins</span>
                                        </div>
                                    </div>
                                    <Button
                                        variant="light"
                                        className="w-100 py-3 fw-bold"
                                        style={{
                                            borderRadius: '50px',
                                            color: '#128C7E'
                                        }}
                                    >
                                        <FaWhatsapp className="me-2" />
                                        Chat on WhatsApp
                                    </Button>
                                </div>
                            </div>
                        </motion.div>
                    </Col>
                </Row>

                {/* Additional Options */}
                <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.8, delay: 0.4 }}
                    viewport={{ once: true }}
                >
                    <Row className="g-3 justify-content-center">
                        <Col xs="auto">
                            <Button
                                variant="outline-primary"
                                className="px-4 py-2"
                                style={{ borderRadius: '50px' }}
                            >
                                Telemedicine Consultation
                            </Button>
                        </Col>
                        <Col xs="auto">
                            <Button
                                variant="outline-primary"
                                className="px-4 py-2"
                                style={{ borderRadius: '50px' }}
                            >
                                Second Opinion
                            </Button>
                        </Col>
                        <Col xs="auto">
                            <Button
                                variant="outline-primary"
                                className="px-4 py-2"
                                style={{ borderRadius: '50px' }}
                            >
                                Insurance Verification
                            </Button>
                        </Col>
                        <Col xs="auto">
                            <Button
                                variant="outline-primary"
                                className="px-4 py-2"
                                style={{ borderRadius: '50px' }}
                            >
                                Pharmacy Services
                            </Button>
                        </Col>
                    </Row>
                </motion.div>

                {/* 24/7 Availability Banner */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.5 }}
                    viewport={{ once: true }}
                    className="mt-5 pt-4"
                >
                    <div
                        className="p-4 rounded text-center"
                        style={{ backgroundColor: 'var(--soft-yellow)' }}
                    >
                        <div className="d-flex flex-column flex-md-row align-items-center justify-content-center">
                            <div className="mb-3 mb-md-0 me-md-4">
                                <FaClock size={32} style={{ color: 'var(--dark-teal)' }} />
                            </div>
                            <div className="text-center text-md-start">
                                <h4 className="fw-bold mb-2" style={{ color: 'var(--dark-teal)' }}>
                                    24/7 Availability Across All Services
                                </h4>
                                <p className="mb-0" style={{ color: '#666' }}>
                                    Emergency, Labor & Delivery, NICU, and Critical Care services available round the clock
                                </p>
                            </div>
                            <div className="mt-3 mt-md-0 ms-md-4">
                                <Button className="btn-primary-teal px-4">
                                    View All Services
                                </Button>
                            </div>
                        </div>
                    </div>
                </motion.div>
            </Container>
        </section>
    );
};

export default EmergencyCTA;